import { useRouter } from 'next/router';
import React from 'react';
import { MainContainer } from 'src/components/shared/layouts/MainContainer';
import { AllBrands } from 'src/components/shared/templates/footer/AllBrands';
import { CategoryBrands } from 'src/components/shared/templates/footer/CategoryBrands';
import { Guide } from 'src/components/shared/templates/footer/OriginalFooter/Guide';
import { Shops } from 'src/components/shared/templates/footer/OriginalFooter/Shops';
import { QuestionnaireSticker } from 'src/components/shared/templates/questionnaire/QuestionnaireSticker';
import {
  CAMPAIGN_FANCL_PAGE_PATH,
  FAVORITES_PAGE_PATH,
  LARGE_CATEGORY_PAGE_PATH,
  MIDDLE_CATEGORY_PAGE_PATH,
  PAYMENT_ERROR_PAGE_PATH,
  PICKUP_SUPPORT_PAGE_PATH,
  PRODUCT_PAGE_PATH,
  RANKING_PAGE_PATH,
  SMALL_CATEGORY_PAGE_PATH,
  TINY_CATEGORY_PAGE_PATH
} from 'src/constants/pagePath';

const CATEGORY_FILTERED_FOOTER_DISPLAY_PAGE_PATHS = [
  LARGE_CATEGORY_PAGE_PATH,
  MIDDLE_CATEGORY_PAGE_PATH,
  SMALL_CATEGORY_PAGE_PATH,
  TINY_CATEGORY_PAGE_PATH,
  PRODUCT_PAGE_PATH
];

export type Props = {
  headingLevel: 'h2' | 'h3';
};

const determineHeadingLevel = (pathname: string): 'h2' | 'h3' => {
  const pathsRequiringH2 = [
    RANKING_PAGE_PATH,
    CAMPAIGN_FANCL_PAGE_PATH,
    FAVORITES_PAGE_PATH,
    PICKUP_SUPPORT_PAGE_PATH,
    PAYMENT_ERROR_PAGE_PATH
  ];
  return pathsRequiringH2.includes(pathname) ? 'h2' : 'h3';
};

export const OriginalFooter: React.FC = () => {
  const { pathname } = useRouter();
  const headingLevel = determineHeadingLevel(pathname);
  const showCategoryFilteredFooter = CATEGORY_FILTERED_FOOTER_DISPLAY_PAGE_PATHS.includes(pathname);

  return (
    <MainContainer>
      <div className="flex flex-col gap-10">
        <div className="grid place-items-center">
          <QuestionnaireSticker />
        </div>
        <div className="flex flex-col semiLg:flex-row gap-10">
          <Shops headingLevel={headingLevel} />
          <Guide headingLevel={headingLevel} />
        </div>
        {showCategoryFilteredFooter ? (
          <CategoryBrands headingLevel={headingLevel} />
        ) : (
          <AllBrands headingLevel={headingLevel} />
        )}
      </div>
    </MainContainer>
  );
};
